<div class="top-menu-container">
  <div class="buttons-container" [ngClass]="{ isHomePage: isHomePage, isAlertCenterPage: isAlertCenterPage }">
    <div class="open-history-button" (click)="toggleShowHistory()"
      [ngClass]="{ isHomePage: isHomePage && !showHistory, isAlertCenterPage: isAlertCenterPage && !showHistory }"
      [matTooltip]="tooltips.polaris.chatHistory">
      @if (showHistory) {
      <img [src]="'/svg/text-bubble-orange.svg' | assetVersion" />
      }@else {
      @if (isHomePage || isAlertCenterPage) {
      <img [src]="'/svg/text-bubble.svg' | assetVersion" />
      } @else {
      <img [src]="'/svg/text-bubble-gray.svg' | assetVersion" />
      }
      }
    </div>
    @if (!isHomePage || isAlertCenterPage) {
    <div class="vertical-line"></div>
    <div class="new-chat-button" (click)="navigateToHome()"
      [ngClass]="{ isHomePage: isHomePage && !showHistory, isAlertCenterPage: isAlertCenterPage && !showHistory }"
      [matTooltip]="tooltips.polaris.newChat">
      <img [src]="(!showHistory && isAlertCenterPage ? '/svg/plus-white.svg' : '/svg/plus-gray.svg') | assetVersion" />
    </div>
    }
  </div>
  <div class="exit-button" *ngIf="showHistory" (click)="showHistory = false">
    <img [src]="'/svg/closeX.svg' | assetVersion" />
  </div>
</div>
<div class="backdrop" *ngIf="showHistory" (click)="showHistory = false"></div>
<div class="chat-history-container" [class.menu-visible]="showHistory" (mouseenter)="onEnterHistory()"
  (mouseleave)="onLeaveHistory()">
  <div class="search-container">
    <input type="text" class="search-input" placeholder="Search Chats" (input)="onSearchInput($event)">
    <img [src]="'/svg/grey-search.svg' | assetVersion" alt="Search" class="search-icon" width="18" height="18" />
  </div>
  <ng-container *ngIf="filteredChats().length > 0 || isLoadingOverview(); else noChats">
    <div class="recent-chats-heading">Recent Chats</div>
    <div class="chat-list" #chatList [class.no-fade]="scrolledToBottom || !isScrollable" (scroll)="onScroll()">
      <div class="chat-item" *ngFor="let chat of filteredChats(); trackBy: trackByChatId; let isLast = last"
        (click)="navigateToChat(chat.id)" [class.active]="isCurrentChat(chat.id)" [class.last]="isLast">
        <div class="chat-title">{{ chat.title }}</div>
      </div>
      <div class="chat-list-loading-overlay" *ngIf="isLoadingOverview()">
        <div class="chat-list-spinner" aria-hidden="true"></div>
      </div>
    </div>
  </ng-container>
  <ng-template #noChats>
    <div class="no-chats">
      <div class="title">{{noChatsMessage()}}</div>
      <div class="subtitle">{{noChatsSubMessage()}}</div>
      <div class="subtitle">{{noChatsExtraMessage()}}</div>
    </div>
  </ng-template>
</div>
